import React from "react";
import NuevoProyecto from "../proyectos/NuevoProyecto";
import ListadoProyectos from "../proyectos/ListadoProyectos";

const Sidebar = () => {
  return (
    <aside>
      <h1>
        Admin<span>Tasks</span>
      </h1>
      <NuevoProyecto />
      <div className="proyectos">
        <ListadoProyectos />
      </div>
    </aside>
  );
};

export default Sidebar;
